import { Subscribe } from "@repo/fika-blog/src/nodes/subscribe"
import { useI18nContext } from "@/i18n/i18n-solid"

export function getEditSubscribe(params: {
  userName: string
  defaultFormId?: string | null
}) {
  const { LL } = useI18nContext()

  return Subscribe.configure({
    userName: params.userName,
    defaultFormId: params.defaultFormId ?? null,
    translations: {
      defaultText: (userName: string) =>
        LL().subscribe.defaultText({ userName }),
      buttonText: LL().subscribe.button(),
      emailPlaceholder: LL().subscribe.emailPlaceholder(),
    },
  })
}
